import React, { useState, useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'

import Navbar from '../../components/navbar/navbar'
import FilterTop from '../../components/filter-top'
import SideFilter, { FilterValues } from '../../components/side-filter'
import ListProperty from '../../components/list-property'
import FooterTop from '../../components/footer-top'
import Footer from '../../components/footer'

import { API_BASE } from '../../utils/api'

interface DBProperty {
    _id: string; title: string; price: number; status: string; type: string;
    city?: string; address?: string; bedrooms?: number; bathrooms?: number; area?: string;
    images?: string[]; isActive: boolean; createdAt: string;
    owner?: { name: string; role: string };
}

// FilterValues interface is now imported from SideFilter

export default function ListLayoutOne() {
    const [searchParams] = useSearchParams()
    const [show, setShow] = useState<boolean>(false)
    const [properties, setProperties] = useState<DBProperty[]>([])
    const [loading, setLoading] = useState(true)
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [totalPages, setTotalPages] = useState(1)

    const [filters, setFilters] = useState<FilterValues>({
        search: searchParams.get('search') || '',
        city: searchParams.get('city') || '',
        type: searchParams.get('type') || '',
        bedrooms: searchParams.get('bedrooms') || '',
        minPrice: searchParams.get('minPrice') || '',
        maxPrice: searchParams.get('maxPrice') || '',
        subCategory: '', furnishing: '', minSize: '', maxSize: '',
        bathrooms: '', buildingAge: '', sellType: '', facing: '',
        postedBy: '', parkingType: '', constructionStatus: '',
        reraRegistered: '', balcony: '',
        liftAvailable: false, powerBackup: false, gatedCommunity: false,
        cornerProperty: false, parkFacing: false, nearbyMetro: false,
        listingType: searchParams.get('listingType') || '',
        projectStatus: searchParams.get('projectStatus') || '',
        locality: ''
    })

    useEffect(() => {
        setLoading(true)
        const params = new URLSearchParams()
        params.set('page', String(page))
        params.set('limit', String(limit))
        if (filters.search) params.set('search', filters.search)
        if (filters.city) params.set('city', filters.city)
        if (filters.type) params.set('type', filters.type)
        if (filters.bedrooms) params.set('bedrooms', filters.bedrooms)
        if (filters.minPrice) params.set('minPrice', filters.minPrice)
        if (filters.maxPrice) params.set('maxPrice', filters.maxPrice)
        if (filters.subCategory) params.set('subCategory', filters.subCategory)
        if (filters.furnishing) params.set('furnishing', filters.furnishing)
        if (filters.minSize) params.set('minSize', filters.minSize)
        if (filters.maxSize) params.set('maxSize', filters.maxSize)
        if (filters.bathrooms) params.set('bathrooms', filters.bathrooms)
        if (filters.buildingAge) params.set('buildingAge', filters.buildingAge)
        if (filters.sellType) params.set('sellType', filters.sellType)
        if (filters.facing) params.set('facing', filters.facing)
        if (filters.postedBy) params.set('postedBy', filters.postedBy)
        if (filters.parkingType) params.set('parkingType', filters.parkingType)
        if (filters.constructionStatus) params.set('constructionStatus', filters.constructionStatus)
        if (filters.reraRegistered) params.set('reraRegistered', filters.reraRegistered)
        if (filters.balcony) params.set('balcony', filters.balcony)
        if (filters.liftAvailable) params.set('liftAvailable', 'true')
        if (filters.powerBackup) params.set('powerBackup', 'true')
        if (filters.gatedCommunity) params.set('gatedCommunity', 'true')
        if (filters.cornerProperty) params.set('cornerProperty', 'true')
        if (filters.parkFacing) params.set('parkFacing', 'true')
        if (filters.nearbyMetro) params.set('nearbyMetro', 'true')
        const statusParam = searchParams.get('status')
        if (statusParam) params.set('status', statusParam)

        fetch(`${API_BASE}/properties?${params.toString()}`)
            .then(r => r.json())
            .then(data => {
                if (data.properties) {
                    setProperties(data.properties)
                    setTotal(data.total)
                    setTotalPages(data.totalPages)
                }
            })
            .catch(console.error)
            .finally(() => setLoading(false))
    }, [page, limit, filters])

    const handleFilterChange = (newFilters: FilterValues) => {
        setFilters(newFilters)
        setPage(1) // reset to page 1 on filter change
    }

    return (
        <>
            <Navbar transparent={false} />
            <section className="gray-simple">
                <div className="container">
                    <div className="row m-0">
                        <FilterTop
                            totalResults={total}
                            showingFrom={properties.length > 0 ? (page - 1) * limit + 1 : 0}
                            showingTo={Math.min(page * limit, total)}
                            currentPage={page}
                            totalPages={totalPages}
                            onPageChange={(p) => setPage(p)}
                        />
                    </div>
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="filter_search_opt">
                                <Link to="#" className="btn btn-dark full-width mb-4" onClick={() => setShow(!show)}>
                                    <span className="svg-icon text-light svg-icon-2hx me-2">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19.0759 3H4.72777C3.95892 3 3.47768 3.83148 3.86067 4.49814L8.56967 12.6949C9.17923 13.7559 9.5 14.9582 9.5 16.1819V19.5072C9.5 20.2189 10.2223 20.7028 10.8805 20.432L13.8805 19.1977C14.2553 19.0435 14.5 18.6783 14.5 18.273V13.8372C14.5 12.8089 14.8171 11.8056 15.408 10.964L19.8943 4.57465C20.3596 3.912 19.8856 3 19.0759 3Z" fill="currentColor" />
                                        </svg>
                                    </span>Open Filter Option
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <SideFilter show={show} setShow={setShow} filters={filters} onFilterChange={handleFilterChange} />
                        </div>
                        <div className="col-lg-8 col-md-12 list-layout">
                            <div className="row justify-content-center g-4">
                                {loading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status"></div>
                                        <p className="mt-2 text-muted">Loading properties...</p>
                                    </div>
                                ) : properties.length === 0 ? (
                                    <div className="text-center py-5">
                                        <i className="fa-solid fa-house-circle-xmark fa-3x text-muted mb-3"></i>
                                        <h5 className="text-muted">No properties found</h5>
                                        <p className="text-muted">Try adjusting your filters</p>
                                    </div>
                                ) : (
                                    properties.map((item) => (
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12" key={item._id}>
                                            <ListProperty item={item} />
                                        </div>
                                    ))
                                )}
                            </div>
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <ul className="pagination p-center">
                                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                            <Link
                                                className="page-link"
                                                to="#"
                                                aria-label="Previous"
                                                onClick={(e) => { e.preventDefault(); if (page > 1) setPage(page - 1); }}
                                            >
                                                <i className="fa-solid fa-arrow-left-long"></i>
                                                <span className="sr-only">Previous</span>
                                            </Link>
                                        </li>
                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                                            <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                <Link
                                                    className="page-link"
                                                    to="#"
                                                    onClick={(e) => { e.preventDefault(); setPage(p); }}
                                                >
                                                    {p}
                                                </Link>
                                            </li>
                                        ))}
                                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                            <Link
                                                className="page-link"
                                                to="#"
                                                aria-label="Next"
                                                onClick={(e) => { e.preventDefault(); if (page < totalPages) setPage(page + 1); }}
                                            >
                                                <i className="fa-solid fa-arrow-right-long"></i>
                                                <span className="sr-only">Next</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <FooterTop bg="theme-bg" />

            <Footer />
        </>
    )
}
